<svg viewBox="0 0 16 2" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.8261 0.333374H0.173913C0.0782609 0.333374 0 0.411635 0 0.507287V1.81164C0 1.90729 0.0782609 1.98555 0.173913 1.98555H15.8261C15.9217 1.98555 16 1.90729 16 1.81164V0.507287C16 0.411635 15.9217 0.333374 15.8261 0.333374Z" fill="white"/>
</svg>
